import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ModalVideos from "../../../../components/ModalVideo/ModalVideos";

import Tilt from "react-parallax-tilt";
import { Link } from "react-router-dom";
import TopNavFour from "../../../../components/header/TopNavFour";
import FancyFeatureTwentyThree from "../../../../components/feature/FancyFeatureTwentyThree";
import CommonCounter from "../../../../components/counter/CommonCounter";
import TestimonialOne from "../../../../components/testimonial/TestimonialOne";
import ContactTwo from "../../../../components/contact/ContactTwo";
import BrandTwo from "../../../../components/brand/BrandTwo";
import FooterFour from "../../../../components/footer/FooterFour";
import CopyRightFour from "../../../../components/footer/CopyRightFour";
import NewsFormTwo from "../../../../components/form/NewsFormTwo";
import { useParams } from 'react-router-dom';

const AboutUsTwo = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const OpenModal = () => {
    setOpen(!open);
  };
  useEffect(() => {
      if (id == "terms_condition") {
      window.scrollTo(0, 100)
    }
    else if(id == "Privacy_Policy"){
      window.scrollTo(0, 1400)
    }
    else if(id == "Cookie_Policy"){
      window.scrollTo(0, 3300)
    }
  }, [id]);
 
  const handleScroll = () => {};
  return (
    <Fragment>
      <div className="main-page-wrapper">
        <ModalVideos isOpen={open} onClick={OpenModal} />
        <Helmet>
          <title>Policy</title>
        </Helmet>
        {/* helmet end */}
        <TopNavFour /> {/* theme-menu-four */}
        <div className="theme-inner-banner space-fix-one" id="terms_condition">
          <div className="container">
            <div className="container">
              <h2 className="intro-title" >
                Terms <span>Conditions</span>
              </h2>
              {/* <ul className="page-breadcrumb style-none d-flex">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="current-page">About us</li>
            </ul> */}
              <br></br>
              <h6>Overview</h6>
              <p>
                The following are the terms of an agreement between you and
                Noteg. By accessing, or using this Web site, you acknowledge
                that you have read, understand, and agree to be bound by these
                terms and to comply with all applicable laws and regulations,
                including export and re-export control laws and regulations. If
                you do not agree to these terms, please do not use this Web
                site.
              </p>
              <h6>General</h6>

              <p>
                Noteg grants you a non-exclusive, non-transferable, limited
                permission to access and display the Web pages within this site
                as a customer or potential customer of IBM provided you comply
                with these Terms of Use, and all copyright, trademark, and other
                proprietary notices remain intact
              </p>

              <h6>Disclaimer</h6>
              <p>
                From time to time, this Web site may contain technical
                inaccuracies or typographical errors, and we do not warrant the
                accuracy of any posted information. Please confirm you are using
                the most up-to-date pages on this Web site, and confirm the
                accuracy and completeness of information before using it to make
                decisions relating to services, products, or other matters
                described in this Web site.
              </p>
              <h6>Confidential information</h6>
              <p>
                Noteg does not want to receive confidential or proprietary
                information from you through our Web site. Please note that any
                information or material sent to Noteg will be deemed NOT to be
                confidential. By sending IBM any information or material, you
                grant Noteg an unrestricted, irrevocable license to copy,
                reproduce, publish, upload, post, transmit, distribute, publicly
                display, perform, modify, create derivative works from, and
                otherwise freely use, those materials or information.{" "}
              </p>
              <h6>Business relationships</h6>
              <p>
                This Web site may provide links or references to non-Noteg Web
                sites and resources. Noteg makes no representations, warranties,
                or other commitments or endorsements whatsoever about any
                non-Noteg Web sites or third-party resources (including any
                Lenovo Web site) that may be referenced, accessible from, or
                linked to any Noteg site. In addition, Noteg is not a party to
                or responsible for any transactions you may enter into with
                third parties, even if you learn of such parties (or use a link
                to such parties) from an Noteg site.
              </p>
              <br></br>
              <br></br>
              <h2 className="intro-title" id="Privacy_Policy">
                Privacy <span>Policy</span>
              </h2>
              <br></br>
              
              {/* <ul className="page-breadcrumb style-none d-flex">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="current-page">About us</li>
            </ul> */}
              <p>
              At NoteG Technologies Private Limited, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and disclose your personal information when you use our mobile app, TaskMaster360.
              <br></br> 
              <br></br>            
              <h6>Information We Collect</h6>
  <p>When you use our app, we may collect the following types of personal information:</p>           
                {/* <p>
                When you use TaskMaster360, we may collect the following types of personal information:
                </p> */}
                 <p1>
                •	Name, email address, and other contact details
                </p1><br></br>
                <p1>• Usernames and passwords</p1><br></br>
                {/* <p1>• Device information, such as the type and model of your mobile device, its unique device identifier, and mobile network information</p1><br></br>
                <p1>•	Usage data, such as the date and time of your visit to TaskMaster360, the features you used, and the pages you visited</p1><br></br> */}
                <p1>•	Location information, if you choose to enable this feature</p1>
              </p>
              {/* <p>We may collect this information directly from you or automatically when you use our app.</p> */}
            <h6>Use of Information</h6>
            <p>We may use your personal information for the following purposes:</p>
            <p1>•	To provide and improve our app</p1><br></br>
            <p1>•	To personalize your experience</p1><br></br>
            <p1>•	To communicate with you, including to respond to your inquiries and provide customer support</p1><br></br>
            <p1>•	To send you marketing and promotional materials, subject to your consent</p1><br></br>
            <p1>•	To comply with legal obligations</p1>
            </div>
            <br></br>
            <h6>Disclosure of Information</h6>
            <p>We may disclose your personal information to the following third parties:</p>
            <p1>•	Law enforcement authorities, regulators, or other government officials, when required by law or to protect our rights or the rights of others</p1><br></br>
            <p1>•	Other users of our app, when you choose to share information with them through the app
Security</p1><br></br>
            <p1>•	We take reasonable measures to protect your personal information from unauthorized access, use, and disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.</p1><br></br>
            {/* <p1>•	Other users of TaskMaster360, when you choose to share information with them through the app</p1> */}
            <br></br>
            <h6>Security</h6>
            <p>We take reasonable measures to protect your personal information from unauthorized access, use, and disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.
</p>
            <h6>Retention</h6>
            <p>We will retain your personal information for as long as necessary to fulfill the purposes for which it was collected, unless a longer retention period is required or permitted by law.</p>
            <h6>Your Rights</h6>
            <p>You may have certain rights with respect to your personal information, such as the right to access, correct, or delete your information. If you wish to exercise these rights, please contact us using the information provided on Contact us section.</p>
            <h6>Changes to this Policy</h6>
            <p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. We will post the updated Privacy Policy on our website and notify you of any material changes.</p>
            <h6>Contact us</h6>
            <p>If you have any questions or concerns about this Privacy Policy or our practices, please contact us at business@notegtechnologies.com</p>
            <br></br>
            <h2 className="intro-title" id="Cookie_Policy">
              Cookie<span>Policy</span>
            </h2>
            <br></br>
            <p>
              Noteg uses cookies (small text files placed on your device) and
              similar technologies to provide our websites and to help collect
              data. The text in a cookie often consists of a string of numbers
              and letters that uniquely identifies your computer, but it can
              contain other information as well.
            </p>
          </div>
        </div>
        <div className="fancy-feature-twelve mt-130 pb-50 lg-mt-80">
          <div className="container">
            <div className="row align-items-center align-items-xl-start">
              <div className="col-xl-5 col-md-6 order-md-last">
                <div className="block-style-nine color-two">
                  <div className="title-style-three pb-10" data-aos="fade-up">
                    <div className="sc-title">WHY CHOOSE US</div>
                    <h2 className="main-title">
                      Why <span>choose us</span> for your business.
                    </h2>
                  </div>
                  {/* /.title-style-three */}
                  <ul className="style-none list-item">
                    <li data-aos="fade-up">
                      Our strong sense of identification with client projects
                      means that we are constantly striving to provide
                      solutions, even for issues they aren’t yet aware of.{" "}
                    </li>
                    <li data-aos="fade-up" data-aos-delay={100}>
                      It’s our attention to the small stuff, scheduling of
                      timelines and keen project management that makes us stand
                      out from the rest.
                    </li>
                    <li data-aos="fade-up" data-aos-delay={200}>
                      We bring our diverse background of advertising, design,
                      branding, public relations, research and strategic
                      planning to work for company.
                    </li>
                  </ul>
                </div>
                {/* /.block-style-nine */}
              </div>
              <div
                className="col-xl-7 col-md-6 order-md-first"
                data-aos="fade-right"
              >
                <div className="illustration-holder position-relative d-inline-block pe-md-5 me-xxl-5 sm-mt-60">
                <Tilt>
                <img
                    src="images/assets/ils_18.svg"
                    alt="Graphics"
                    className="transform-img-meta"
                  />
                </Tilt>      
                </div>
                
              </div>
            </div>
          </div>
          {/* <img
            src="images/shape/shape_25.svg"
            alt=""
            className="shapes bg-shape"
          /> */}
        </div>
        {/* /.fancy-feature-twelve */}
        <div className="counter-section-one mt-100">
          <div className="container">
            <div className="inner-container bg-color">
              <CommonCounter />
            </div>
            {/* /.inner-container */}
          </div>
        </div>
        {/* /.counter-section-one */}
        <div className="feedback-section-four position-relative mt-150 pb-75 lg-mt-110 sm-pb-20">
          <div className="container">
            <div className="title-style-three text-center" data-aos="fade-up">
              <div className="sc-title">Testimonials</div>
              <h2 className="main-title">
                Trusted by <span>Clients</span>
              </h2>
            </div>
            {/* /.title-style-three */}
          </div>
          {/* /.container */}
          <div className="inner-content mt-90 lg-mt-60">
            <div className="slider-wrapper">
              <TestimonialOne />
              {/* /.feedback_slider_one */}
            </div>
            {/* /.slider-wrapper */}
          </div>
          {/* /.inner-content */}
          <div className="mt-100 lg-mt-70">
            <div className="container">
              <ContactTwo />
            </div>
          </div>
          {/* <img
            src="images/shape/shape_46.svg"
            alt=""
            className="shapes bg-shape"
          /> */}
        </div>
        {/* /.feedback-section-four */}
        <div className="partner-section-two mb-130 lg-mb-80">
          <div className="container">
            <div className="row">
              <div className="col-12 m-auto">
                <BrandTwo />
              </div>
            </div>
          </div>
          {/* /.container */}
        </div>
        {/* /.partner-section-two */}
        <div className="footer-style-four theme-basic-footer">
          <div className="container">
            <div className="inner-wrapper">
              <div className="subscribe-area">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="title-style-four sm-pb-20">
                      <h4 className="main-title">
                        Join Our <span>Newsletter</span> &amp; Get updated.
                      </h4>
                    </div>
                    {/* /.title-style-four */}
                  </div>
                  <div className="col-md-6">
                    <div className="subscribe-form">
                      <NewsFormTwo />
                      <p>We only send interesting and relevant emails.</p>
                    </div>
                    {/* /.subscribe-form */}
                  </div>
                </div>
              </div>
              {/* /.subscribe-area */}
              <FooterFour />
              <div className="bottom-footer">
                <CopyRightFour />
              </div>
            </div>
            {/* /.inner-wrapper */}
          </div>
        </div>
        {/* /.footer-style-four */}
      </div>
    </Fragment>
  );
};

export default AboutUsTwo;
